import Evaluation from "../../Evaluation"
import { DecisionReason, Experiment, ParameterConfiguration, Variation, VariationId, VariationKey } from "../../../model/model"
import { ExperimentEvaluateResult } from "./ExperimentEvaluateResult"

export default class ExperimentEvaluation implements Evaluation {
  constructor(readonly entity: Experiment, readonly result: ExperimentEvaluateResult) {}

  get experiment(): Experiment {
    return this.entity
  }

  get variation(): Variation {
    return this.result.variation
  }

  get variationId(): VariationId | undefined {
    return this.result.variation.id
  }

  get variationKey(): VariationKey {
    return this.result.variation.key
  }

  get config(): ParameterConfiguration | undefined {
    return this.result.variation.config
  }

  with(reason: DecisionReason): ExperimentEvaluation {
    return new ExperimentEvaluation(this.entity, this.result.with(reason))
  }
}
